import React from 'react';
import { Button, Form, Input,message } from 'antd';
import { hnrequest, setTokenhn as _setTokenhn } from '@/utils'
import { useNavigate } from 'react-router-dom';
import md5 from "js-md5";

const Hnlogin = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate()
  const onFinish = async (values) => {
    const md5psw = md5(values['password']);
    const o2 = { password: md5psw };
    const loginFrom2 = Object.assign(values, o2);
    const res = await hnrequest.post('/login', loginFrom2)

    if (res.return_code === 'success') {
      messageApi.success(res.return_msg)
      _setTokenhn(res.token)
      localStorage.setItem("ticks",res.ticks)
      navigate('/hn')

    } else {
      messageApi.warning(res.return_msg)

    }
  
  }




  return <>{contextHolder}
  <Form onFinish={onFinish}
    validateTrigger="onBlur"
  >
    <Form.Item
      name="username"
      rules={[
        { required: true, message: '请输入用户名!' },
        // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号!' }
      ]}
    >
      <Input placeholder="请输入用户名!" autoComplete="true" />
    </Form.Item>
    <Form.Item
      name="password"
      rules={[{ required: true, message: '请输入密码!' }]}
    >
      <Input.Password

        type="password"
        placeholder="请输入密码!"
        autoComplete="true"
      />
    </Form.Item>

    <Form.Item>
      <Button type="primary" htmlType="submit" block={true} >
        登   录
      </Button>


    </Form.Item>
  </Form>




  </>

}
export default Hnlogin